import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const banners = [{
  id: 1,
  src: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2021/04/tinywow_VK-BANNER-03-2_8920614.png?fit=1920%2C960&ssl=1',
  alt: 'Victory Kitchen Z - Authentic African Cuisine'
}, {
  id: 2,
  src: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2021/04/Features-victory-banner-bcgrd.png?fit=1640%2C924&ssl=1',
  alt: 'Victory Kitchen Z - Our Features'
}, {
  id: 3,
  src: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/07/Features-victory-banner-bcgrd-2.png?fit=1640%2C924&ssl=1',
  alt: 'Victory Kitchen Z - Quality & Service'
}];
export function BannerSlider() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section className="w-full bg-charcoal py-6 md:py-10 overflow-hidden" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl border border-white/10" style={{
        aspectRatio: '16/8'
      }} data-id="element-25">
          <AnimatePresence mode="wait" data-id="element-26">
            <motion.img key={banners[current].id} src={banners[current].src} alt={banners[current].alt} initial={{
            opacity: 0,
            scale: 1.05
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.6,
            ease: 'easeInOut'
          }} className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-27" />
          </AnimatePresence>

          {/* Dots Navigation */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2.5 z-20" data-id="element-28">
            {banners.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`rounded-full transition-all duration-300 ${i === current ? 'w-8 h-3 bg-amber shadow-md' : 'w-3 h-3 bg-white/50 hover:bg-white/80'}`} aria-label={`Go to slide ${i + 1}`} data-id="element-29" />)}
          </div>
        </div>
      </div>
    </section>;
}